$(function () {
    $('[data-smoothscroll]').on('click', function (event) {
        event.preventDefault();
        window.scrollTo('#' + $(this).data('smoothscroll'));
    });
    $(window).on('load', function () {
        if (window.location.hash) {
            window.scrollTo(window.location.hash);
        }
    });
});

window.scrollTo = function (targetName) {
    const target = $(targetName);

    if (!target.length) {
        console.log('Smoothscroll kan de volgende module niet vinden:', targetName);
        return;
    }

    // console.log('Smoothscroll scrollen naar module:', targetName);

    let offset = target.offset().top;

    offset -= $('.header').outerHeight();
    // offset -= 100;

    // console.log('Smoothscroll offset is:', offset);

    $('html, body').animate({
        scrollTop: offset,
    }, 1000);
};

$(document).on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
    let attr = $(this).attr('href');
    let target = $(document.getElementById(attr.replace('#', '')));
    if (!target.length) {
      return;
    }

    $('html, body').animate(
      {
        scrollTop: target.offset().top - 150,
      },
      1000,
      'swing'
    );
  });
